import { loginService } from "@/api/services/loginService";
import { UserVo } from "@supplier/entity";
import { useUserStore } from "@/stores/modules/user";

export const getUserInfo = async () => {
    try {
        const userStore = useUserStore();
        const data: UserVo = await loginService.getUserInfo();
        await userStore.setUserInfo(data);
        userStore.setMobile(data.user.mobile);
        // 企业认证状态
        userStore.setEnterpriseAuth(data.supplier.applyState);
    } catch (e) {
        console.log(e);
    }
};
